import React from 'react';
import PropTypes from 'prop-types';
import { generateMoreInfoItems } from '../../utils';
import { Link } from '../../styled';

const MoreInfoSection = ({ onClose }) => {
  const moreInfoItems = generateMoreInfoItems(onClose);

  return moreInfoItems.map((item, i) => {
    if (item.url) {
      return (
        <Link
          to={item.url}
          onClick={item.onClick}
          exact
          key={item.label}
          variant={item.variant}
        >
          {item.icon} {item.label}
        </Link>
      );
    }
    return (
      <Link
        as="a"
        href={item.externalUrl}
        target="_blank"
        key={item.label}
        variant={item.variant}
        rel="noopener noreferrer"
      >
        {item.icon} {item.label}
      </Link>
    );
  });
};

MoreInfoSection.propTypes = {
  onClose: PropTypes.func
};

export default MoreInfoSection;
